(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("lhKg5", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $f7ef11746724ae31$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $f7ef11746724ae31$var$IconCart(Props) {
    var sizeOpt = Props.size;
    var className = Props.className;
    var size = sizeOpt !== undefined ? sizeOpt : 24;
    var tmp = {
        height: size.toString(),
        width: size.toString(),
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.8",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1 -2.966 2.544h-6.852a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304z"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M9 11v-5a3 3 0 0 1 6 0v5"
    }));
}
$f7ef11746724ae31$var$IconCart.displayName = "IconCart";
var $f7ef11746724ae31$export$dd44f18ab656f3bb = $f7ef11746724ae31$var$IconCart;
 /* react Not a pure module */ 
});

parcelRegister("6Ntmr", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $4f2e182a43046b2f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $9pMGg = parcelRequire("9pMGg");
function $4f2e182a43046b2f$var$CartAnimation(Props) {
    var loopOpt = Props.loop;
    var productDirectionOpt = Props.productDirection;
    var tooltipDirectionOpt = Props.tooltipDirection;
    var addedLabelOpt = Props.addedLabel;
    var classNameOpt = Props.className;
    var enabledOpt = Props.enabled;
    var loop = loopOpt !== undefined ? loopOpt : false;
    var productDirection = productDirectionOpt !== undefined ? productDirectionOpt : /* Left */ 2;
    var tooltipDirection = tooltipDirectionOpt !== undefined ? tooltipDirectionOpt : /* Left */ 2;
    var addedLabel = addedLabelOpt !== undefined ? addedLabelOpt : "Added!";
    var className = classNameOpt !== undefined ? classNameOpt : $ezf3v.prefix("relative w-5 h-5 bg-red-600");
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var match = $9pMGg.use(undefined);
    var setLastProductAddedToCart = match.setLastProductAddedToCart;
    var product = match.lastProductAddedToCart;
    $g85JO.useEffect(function() {
        return function(param) {
            $iv6Yc._1(setLastProductAddedToCart, function(param) {});
        };
    }, []);
    var renderTooltip = function renderTooltip(param) {
        var match = addedLabel.trim();
        if (match === "") return null;
        var tmp;
        switch(tooltipDirection){
            case /* Top */ 0:
                tmp = "animate-cart-tooltip-top left-1/2 bottom-full mb-8";
                break;
            case /* Bottom */ 1:
                tmp = "animate-cart-tooltip-bottom left-1/2 top-full mt-8";
                break;
            case /* Left */ 2:
                tmp = "animate-cart-tooltip-left top-1/2 right-full mr-8";
                break;
            case /* Right */ 3:
                tmp = "animate-cart-tooltip-right top-1/2 left-full ml-8";
                break;
            case /* BottomRight */ 4:
                tmp = "animate-cart-tooltip-bottom right-0 top-full mt-8";
                break;
            case /* BottomLeft */ 5:
                tmp = "animate-cart-tooltip-bottom left-0 top-full mt-8";
                break;
        }
        var tmp$1;
        var exit = 0;
        switch(tooltipDirection){
            case /* Top */ 0:
            case /* Bottom */ 1:
                exit = 2;
                break;
            case /* Left */ 2:
            case /* Right */ 3:
                exit = 1;
                break;
            case /* BottomRight */ 4:
                tmp$1 = /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("absolute w-4 h-4 bg-primary"),
                    style: {
                        bottom: "auto",
                        right: "5%",
                        top: "-11px",
                        clipPath: "polygon(50% 50%, 0% 100%, 100% 100%)"
                    }
                });
                break;
            case /* BottomLeft */ 5:
                tmp$1 = /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("absolute w-4 h-4 bg-primary"),
                    style: {
                        bottom: "auto",
                        left: "5%",
                        top: "-11px",
                        clipPath: "polygon(50% 50%, 0% 100%, 100% 100%)"
                    }
                });
                break;
        }
        switch(exit){
            case 1:
                tmp$1 = /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("absolute w-4 h-4 bg-primary"),
                    style: {
                        left: tooltipDirection === /* Right */ 3 ? "-11px" : "auto",
                        right: tooltipDirection === /* Right */ 3 ? "auto" : "-11px",
                        top: "50%",
                        clipPath: tooltipDirection === /* Right */ 3 ? "polygon(100% 0, 50% 50%, 100% 100%)" : "polygon(0 0, 0 100%, 50% 50%)",
                        transform: "translateY(-50%)"
                    }
                });
                break;
            case 2:
                tmp$1 = /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("absolute w-4 h-4 bg-primary"),
                    style: {
                        bottom: tooltipDirection === /* Bottom */ 1 ? "auto" : "-11px",
                        left: "50%",
                        top: tooltipDirection === /* Bottom */ 1 ? "-11px" : "auto",
                        clipPath: tooltipDirection === /* Bottom */ 1 ? "polygon(50% 50%, 0% 100%, 100% 100%)" : "polygon(50% 50%, 0 0, 100% 0)",
                        transform: "translateX(-50%)"
                    }
                });
                break;
        }
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "absolute bg-primary text-main rounded-custom opacity-0 whitespace-nowrap shadow-lg px-3 py-2 text-base",
                tmp,
                loop ? "force-loop" : ""
            ]))
        }, tmp$1, addedLabel);
    };
    var renderProductImage = function renderProductImage(product) {
        var firstImage = $7KlbQ.Media.getImageUrlWithPosterFallback(product.media);
        var tmp;
        switch(productDirection){
            case /* Top */ 0:
                tmp = "animate-cart-product-top top-1/2 left-1/2";
                break;
            case /* Left */ 2:
                tmp = "animate-cart-product-left left-1/2 top-1/2";
                break;
            case /* Right */ 3:
                tmp = "animate-cart-product-right left-1/2 top-1/2";
                break;
            case /* Bottom */ 1:
            case /* BottomRight */ 4:
            case /* BottomLeft */ 5:
                tmp = "animate-cart-product-bottom top-1/2 left-1/2";
                break;
        }
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "absolute rounded-custom bg-main shadow-lg relative p-0.5 w-12 h-12 bg-opacity-80",
                tmp,
                loop ? "force-loop" : ""
            ]))
        }, firstImage !== undefined ? /*#__PURE__*/ $g85JO.createElement($55MCT.Sized.make, {
            src: firstImage,
            containerWidth: 32,
            containerHeight: 32,
            fit: /* Cover */ 1,
            priority: 1,
            alt: $2whNH.getWithDefault(product.name, "Product image")
        }) : null);
    };
    if (product !== undefined && enabled) return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $1TRFX.make([
            className,
            $ezf3v.prefix("top-0 left-0 flex items-center justify-center")
        ])
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative inline-block w-5 h-5")
    }, renderTooltip(undefined), renderProductImage(product)));
    else return null;
}
$4f2e182a43046b2f$var$CartAnimation.displayName = "CartAnimation";
var $4f2e182a43046b2f$export$dd44f18ab656f3bb = $4f2e182a43046b2f$var$CartAnimation;
 /* react Not a pure module */ 
});

parcelRegister("4135i", function(module, exports) {

$parcel$export(module.exports, "useCheckoutAction", function () { return $2ec9a5ef2dafd1af$export$c81caffb17b2cd54; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $eklj4 = parcelRequire("eklj4");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $dzlIC = parcelRequire("dzlIC");

var $9pMGg = parcelRequire("9pMGg");

var $lihS4 = parcelRequire("lihS4");

var $8E2YL = parcelRequire("8E2YL");
function $2ec9a5ef2dafd1af$export$c81caffb17b2cd54(param) {
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var settings = match$1.settings;
    var match$2 = $9pMGg.use(undefined);
    var redirectToLink = match$2.redirectToLink;
    var trackEvent = match$2.trackEvent;
    var match$3 = $lihS4.useCart(undefined);
    var setShowCartDrawer = match$3.setShowCartDrawer;
    var openLinkInNewTab = settings.openLinkInNewTab;
    var checkoutCustomAction = $2whNH.flatMap(match$1.transitiveAccount, function(account) {
        return $i7mYY.getBy(account.customActions, function(action) {
            return $7bjme.equal($loT9g.some(action.id), settings.checkoutCustomAction);
        });
    });
    var trackCheckout = function trackCheckout(e) {
        $iv6Yc.app(trackEvent, [
            "checkout",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var match$4 = settings.checkoutLink;
    var exit = 0;
    if (setShowCartDrawer !== undefined) {
        if (settings.cart) return {
            href: undefined,
            onClick: function onClick(e) {
                $iv6Yc._1(setShowCartDrawer, function(param) {
                    return true;
                });
            }
        };
        exit = 2;
    } else exit = 2;
    if (exit === 2 && checkoutCustomAction !== undefined) {
        var code = checkoutCustomAction.onClickFn;
        if (code !== undefined && match$4 !== undefined) return {
            href: undefined,
            onClick: function onClick(e) {
                trackCheckout(e);
                $eklj4.$$catch($dzlIC.triggerCustomFunctionWithoutProducts(code, "checkout", undefined, undefined), function(param) {
                    return Promise.resolve($2whNH.forEach(settings.checkoutLink, function(__x) {
                        $iv6Yc._5(redirectToLink, undefined, undefined, undefined, openLinkInNewTab, __x);
                    }));
                });
            }
        };
    }
    if (match$4 !== undefined) return {
        href: match$4,
        onClick: trackCheckout
    };
    else return {
        href: match$3.storeCheckoutLink,
        onClick: undefined
    };
}
 /* CustomScript-Showside Not a pure module */ 
});

parcelRegister("3Q6OI", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $2cbb84276a685fa5$export$c08352ad19c25332; });
$parcel$export(module.exports, "ofElement", function () { return $2cbb84276a685fa5$export$f5fec2f60b925e79; });

var $amOA8 = parcelRequire("amOA8");

var $cstWc = parcelRequire("cstWc");

var $b5aRK = parcelRequire("b5aRK");

var $5OXjM = parcelRequire("5OXjM");

var $f70MN = parcelRequire("f70MN");
function $2cbb84276a685fa5$export$c08352ad19c25332(T) {
    var contentEditable = function contentEditable(self) {
        return $cstWc.decodeContentEditable(self.contentEditable);
    };
    var setContentEditable = function setContentEditable(self, value) {
        self.contentEditable = $cstWc.encodeContentEditable(value);
    };
    var dir = function dir(self) {
        return $cstWc.decodeDir(self.dir);
    };
    var setDir = function setDir(self, value) {
        self.dir = $cstWc.encodeDir(value);
    };
    return {
        ofElement: $b5aRK.asHtmlElement,
        contentEditable: contentEditable,
        setContentEditable: setContentEditable,
        dir: dir,
        setDir: setDir
    };
}
var $2cbb84276a685fa5$var$include = $amOA8.Impl({});
$5OXjM.Impl({});
$f70MN.Impl({});
var $2cbb84276a685fa5$var$include$1 = $b5aRK.Impl({});
function $2cbb84276a685fa5$export$d9d317b4285c34e7(self) {
    return $cstWc.decodeContentEditable(self.contentEditable);
}
function $2cbb84276a685fa5$export$91a56ab73e46c5d4(self, value) {
    self.contentEditable = $cstWc.encodeContentEditable(value);
}
function $2cbb84276a685fa5$export$147ec2801e896265(self) {
    return $cstWc.decodeDir(self.dir);
}
function $2cbb84276a685fa5$export$5d00cbe77a0f4da4(self, value) {
    self.dir = $cstWc.encodeDir(value);
}
var $2cbb84276a685fa5$export$4debbe1037afe35e = $2cbb84276a685fa5$var$include.nodeType;
var $2cbb84276a685fa5$export$83b3005418b2b918 = $2cbb84276a685fa5$var$include$1.asHtmlElement;
var $2cbb84276a685fa5$export$b09cfa9b7e510069 = $2cbb84276a685fa5$var$include$1.ofNode;
var $2cbb84276a685fa5$export$bcf37bc7ac72b44e = $2cbb84276a685fa5$var$include$1.insertAdjacentElement;
var $2cbb84276a685fa5$export$56db5d470f98d841 = $2cbb84276a685fa5$var$include$1.insertAdjacentHTML;
var $2cbb84276a685fa5$export$63b055236462c0b2 = $2cbb84276a685fa5$var$include$1.insertAdjacentText;
var $2cbb84276a685fa5$export$f5fec2f60b925e79 = $b5aRK.asHtmlElement;
 /* include Not a pure module */ 
});

parcelRegister("2wB5I", function(module, exports) {

$parcel$export(module.exports, "usePausePageScrolling", function () { return $1d6b57790b72ff05$export$6c019b30eb5dae80; });
$parcel$export(module.exports, "useIsPausing", function () { return $1d6b57790b72ff05$export$1f73c3396f2db8f7; });
$parcel$export(module.exports, "make", function () { return $1d6b57790b72ff05$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $efwy1 = parcelRequire("efwy1");

var $3Q6OI = parcelRequire("3Q6OI");
function $1d6b57790b72ff05$export$c2a6433281518c91(param) {
    return $loT9g.nullable_to_opt(document.querySelector("html"));
}
function $1d6b57790b72ff05$export$307b18b61172f7ed(param) {
    return "QVTW__body-no-scroll";
}
var $1d6b57790b72ff05$export$b89c5c1b934d8237 = {};
function $1d6b57790b72ff05$export$6c019b30eb5dae80(param) {
    var namespace = $efwy1.useNamespaceAsString(undefined);
    $g85JO.useEffect(function() {
        var runCallbacks = function runCallbacks(el) {
            $i7mYY.forEach($2whNH.getWithDefault($d3YYW.get($1d6b57790b72ff05$export$b89c5c1b934d8237, namespace), []), function(callback) {
                $iv6Yc._1(callback, el);
            });
        };
        var addClassName = function addClassName(param) {
            $2whNH.forEach($loT9g.nullable_to_opt(document.querySelector("html")), function(page) {
                page.setAttribute("class", (page.className + " QVTW__body-no-scroll").trim());
            });
            runCallbacks(undefined);
        };
        var forceFirefoxEnableScrolling = function forceFirefoxEnableScrolling(param) {
            var style = $2whNH.map($2whNH.flatMap($loT9g.nullable_to_opt(document.querySelector("html")), $3Q6OI.ofElement), function(prim) {
                return prim.style;
            });
            $2whNH.forEach(style, function(__x) {
                __x.setProperty("overflow", "auto");
            });
            setTimeout(function(param) {
                $2whNH.map(style, function(__x) {
                    return __x.removeProperty("overflow");
                });
            }, 42);
        };
        var removeClassName = function removeClassName(param) {
            $2whNH.forEach($loT9g.nullable_to_opt(document.querySelector("html")), function(page) {
                page.setAttribute("class", page.className.replace(new RegExp("QVTW__body-no-scroll"), "").trim());
            });
            forceFirefoxEnableScrolling(undefined);
            runCallbacks(undefined);
        };
        addClassName(undefined);
        return removeClassName;
    }, []);
}
function $1d6b57790b72ff05$var$PausePageScrolling(Props) {
    $1d6b57790b72ff05$export$6c019b30eb5dae80(undefined);
    return null;
}
$1d6b57790b72ff05$var$PausePageScrolling.displayName = "PausePageScrolling";
function $1d6b57790b72ff05$export$1f73c3396f2db8f7(param) {
    var namespace = $efwy1.useNamespaceAsString(undefined);
    var getState = function getState(el) {
        return $2whNH.getWithDefault($2whNH.map(el, function(page) {
            return page.classList.contains("QVTW__body-no-scroll");
        }), false);
    };
    var match = $g85JO.useState(function() {
        return getState($loT9g.nullable_to_opt(document.querySelector("html")));
    });
    var setIsPausing = match[1];
    $g85JO.useEffect(function() {
        var setIsPausing$1 = function setIsPausing$1(param) {
            $iv6Yc._1(setIsPausing, function(param) {
                return getState($loT9g.nullable_to_opt(document.querySelector("html")));
            });
        };
        $1d6b57790b72ff05$export$b89c5c1b934d8237[namespace] = $i7mYY.concat($2whNH.getWithDefault($d3YYW.get($1d6b57790b72ff05$export$b89c5c1b934d8237, namespace), []), [
            setIsPausing$1
        ]);
        return function(param) {
            $1d6b57790b72ff05$export$b89c5c1b934d8237[namespace] = $i7mYY.keep($2whNH.getWithDefault($d3YYW.get($1d6b57790b72ff05$export$b89c5c1b934d8237, namespace), []), function(callback) {
                return callback !== setIsPausing$1;
            });
        };
    }, []);
    return match[0];
}
var $1d6b57790b72ff05$export$dd44f18ab656f3bb = $1d6b57790b72ff05$var$PausePageScrolling;
 /* react Not a pure module */ 
});

parcelRegister("g3aLS", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $baf5481c911864dc$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "make", function () { return $baf5481c911864dc$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $lybpH = parcelRequire("lybpH");

var $i3Bxr = parcelRequire("i3Bxr");

var $8wpG4 = parcelRequire("8wpG4");

var $aSJcu = parcelRequire("aSJcu");

var $iCVlB = parcelRequire("iCVlB");

var $8E2YL = parcelRequire("8E2YL");
var $baf5481c911864dc$var$initialValue_options = [];
function $baf5481c911864dc$var$initialValue_onChangeGridDensity(prim) {}
var $baf5481c911864dc$export$f36c9b20522c59e3 = {
    gridColumns: /* FourColumnGrid */ 3,
    isZoomEnabled: false,
    isSmallestPossibleGrid: false,
    options: $baf5481c911864dc$var$initialValue_options,
    onChangeGridDensity: $baf5481c911864dc$var$initialValue_onChangeGridDensity
};
var $baf5481c911864dc$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext($baf5481c911864dc$export$f36c9b20522c59e3);
var $baf5481c911864dc$export$ca328f169d304df4 = $baf5481c911864dc$export$a078c61943f9dbbe.Provider;
function $baf5481c911864dc$var$GridDensityZoomProvider(Props) {
    var children = Props.children;
    var isBombayshirts = $iCVlB.useIsBombay(undefined);
    var match = $8E2YL.use(undefined).config;
    var match$1 = $aSJcu.use(undefined);
    var isMobile = match$1.isMobile;
    var isPLP = $lybpH.useIsPLP(undefined);
    var isZoomEnabled = match.settings.gridDensityZoomEnabled && isPLP;
    var options = isBombayshirts && isMobile ? [
        /* OneColumnGrid */ 0,
        /* TwoColumnGrid */ 1
    ] : isBombayshirts ? [
        /* TwoColumnGrid */ 1,
        /* ThreeColumnGrid */ 2
    ] : isMobile ? [
        /* OneColumnGrid */ 0,
        /* TwoColumnGrid */ 1,
        /* FourColumnGrid */ 3
    ] : [
        /* TwoColumnGrid */ 1,
        /* ThreeColumnGrid */ 2,
        /* FourColumnGrid */ 3,
        /* TwelveColumnGrid */ 8
    ];
    var defaultGridColumns = isBombayshirts && isMobile ? /* TwoColumnGrid */ 1 : isBombayshirts ? /* ThreeColumnGrid */ 2 : isMobile ? /* TwoColumnGrid */ 1 : /* FourColumnGrid */ 3;
    var match$2 = $g85JO.useState(function() {
        return $2whNH.mapWithDefault($8wpG4.get(undefined, "gridColumns"), defaultGridColumns, $i3Bxr.GridColumns.fromString);
    });
    var setCustomGridColumns = match$2[1];
    var gridColumns = isZoomEnabled ? match$2[0] : defaultGridColumns;
    var gridColumns$1 = isMobile ? gridColumns > /* FourColumnGrid */ 3 ? /* FourColumnGrid */ 3 : gridColumns : gridColumns < /* TwoColumnGrid */ 1 ? /* TwoColumnGrid */ 1 : gridColumns;
    var isSmallestPossibleGrid = isZoomEnabled ? isMobile ? gridColumns$1 === /* FourColumnGrid */ 3 : gridColumns$1 >= /* TwelveColumnGrid */ 8 : false;
    var handleChangeGridColumns = $g85JO.useCallback(function(gridColumns) {
        if (isZoomEnabled) {
            $iv6Yc._1(setCustomGridColumns, function(param) {
                return gridColumns;
            });
            return $8wpG4.set(undefined, "gridColumns", $i3Bxr.GridColumns.toString(gridColumns));
        }
    }, [
        isZoomEnabled
    ]);
    var ctxValue = $g85JO.useMemo(function() {
        return {
            gridColumns: gridColumns$1,
            isZoomEnabled: isZoomEnabled,
            isSmallestPossibleGrid: isSmallestPossibleGrid,
            options: options,
            onChangeGridDensity: handleChangeGridColumns
        };
    }, [
        gridColumns$1,
        isZoomEnabled,
        isSmallestPossibleGrid,
        handleChangeGridColumns
    ]);
    return /*#__PURE__*/ $g85JO.createElement($baf5481c911864dc$export$ca328f169d304df4, {
        value: ctxValue,
        children: children
    });
}
$baf5481c911864dc$var$GridDensityZoomProvider.displayName = "GridDensityZoomProvider";
function $baf5481c911864dc$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($baf5481c911864dc$export$a078c61943f9dbbe);
}
var $baf5481c911864dc$export$5561c80b9c5201f5 = /* FourColumnGrid */ 3;
var $baf5481c911864dc$export$9952ee58d89bca88 = /* TwoColumnGrid */ 1;
var $baf5481c911864dc$export$dd44f18ab656f3bb = $baf5481c911864dc$var$GridDensityZoomProvider;
 /* context Not a pure module */ 
});

})();
//# sourceMappingURL=PDPApp.bs.207c76df.js.map
